export enum ThemeType {
  Dark = 'dark',
  Light = 'light',
  ClassicDark = 'classic-dark',
  ClassicLight = 'classic-light',
  FiordNight = 'fiord-night',
}
